import { Grid, Typography } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import { formatDate } from "../AthleteDetails";
import useStyles from "./ProfileCard.styles";

const ProfileCard = ({ athlete }: { athlete: Profile | null }) => {
  const classes = useStyles();

  return (
    athlete && (
      <Grid container className={classes.profileInformationContainer} gap={3}>
        <Grid item xs={12}>
          <Typography variant="h5">Profile</Typography>
        </Grid>

        <Grid
          item
          container
          marginTop={2}
          xs={12}
          className={classes.profileInformationColumnContainer}
        >
          <Grid container>
            <Typography
              variant="subtitle1"
              fontWeight={"bold"}
              color={"black"}
              textTransform={"uppercase"}
            >
              Personal Data
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Age
            </Typography>

            <Typography variant="caption">
              {athlete.birthday
                ? Math.floor(
                    (Date.now() - new Date(athlete.birthday).getTime()) /
                      (365.25 * 24 * 60 * 60 * 1000),
                  )
                : "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Height
            </Typography>

            <Typography variant="caption">
              {athlete.height ? `${athlete.height} in` : "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Weight
            </Typography>

            <Typography variant="caption">
              {athlete.weight ? `${athlete.weight} lb` : "-"}
            </Typography>
          </Grid>

          <Grid
            container
            className={classes.profileInformationRow}
            style={{ borderBottom: "0px" }}
          >
            <Typography variant="caption" color={"#666666"}>
              Gender
            </Typography>

            <Typography variant="caption">
              {athlete.gender ? athlete.gender : "-"}
            </Typography>
          </Grid>
          {/* </Grid> */}
        </Grid>

        {/* ADDRESS DETAILS */}
        <Grid
          item
          container
          marginTop={2}
          xs={12}
          className={classes.profileInformationColumnContainer}
        >
          {/* <Grid container> */}
          <Grid container>
            <Typography
              variant="subtitle1"
              fontWeight={"bold"}
              color={"black"}
              textTransform={"uppercase"}
            >
              Address
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Address 1
            </Typography>

            <Typography variant="caption">
              {athlete.shippingAddress?.addressLine1 || "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Address 2
            </Typography>

            <Typography variant="caption">
              {athlete.shippingAddress?.addressLine2 || "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              City
            </Typography>

            <Typography variant="caption">
              {athlete.shippingAddress?.city || "-"}
            </Typography>
          </Grid>

          <Grid
            container
            className={classes.profileInformationRow}
            style={{ borderBottom: "0px" }}
          >
            <Typography variant="caption" color={"#666666"}>
              State
            </Typography>

            <Typography variant="caption">
              {athlete.shippingAddress?.state || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default ProfileCard;
